import { render, staticRenderFns } from "./PageEight.vue?vue&type=template&id=928ad512&scoped=true"
import script from "./PageEight.vue?vue&type=script&lang=js"
export * from "./PageEight.vue?vue&type=script&lang=js"
import style0 from "./PageEight.vue?vue&type=style&index=0&id=928ad512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928ad512",
  null
  
)

export default component.exports